exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  padding-left: 15px;\n  vertical-align: middle;\n  display: table-cell; }\n\n::ng-deep .icons {\n  width: 40px; }\n  ::ng-deep .icons .oi {\n    cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/table/table-cell/table-cell.component.scss
// module id = ../../../../../src/app/shared/components/table/table-cell/table-cell.component.scss
// module chunks = 12